'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var o, r, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(r = 0; r < l.length; r++)o = l[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var o, r, n = {}, l = Object.keys(e);
    for(r = 0; r < l.length; r++)o = l[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const ModalDialogNav = renderWithRef('ModalDialogNav', null, (n, a)=>{
    var { children: c } = n, p = _object_without_properties(n, [
        "children"
    ]);
    let s = useRef(null), { showDialog: m } = useModalDialogContext();
    return useEffect(()=>{
        if (!s.current || !m) return;
        let e = s.current.offsetHeight;
        document.documentElement.style.setProperty('--swan-internal-modal-dialog-nav-height', `${e}px`);
    }, [
        m
    ]), jsx(RenderComp, {
        root: "div",
        forwardedRef: assignRefs(a, s),
        props: p,
        classNames: [
            'swan-modal-dialog-nav'
        ],
        children: c
    });
});

export { ModalDialogNav };
